export const STACK_TAG_NAME = "stack" as const;

export const STACK_GAPS = [
  "none",
  "xs",
  "sm",
  "md",
  "lg",
  "xl",
  "xxl",
] as const;

export const STACK_ALIGNS = ["stretch", "start", "center", "end"] as const;
